import { GoogleMapsState } from '@/store/modules/google-maps/types'
import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { getters } from '@/store/modules/google-maps/getters'
import { actions } from '@/store/modules/google-maps/actions'
import { mutations } from '@/store/modules/google-maps/mutations'

export const state: GoogleMapsState = {
  infoview: {
    status: {
      active: false,
      selectedMarker: undefined
    },
    title: '',
    subtitle: '',
    emptyResponse: 'Origen sin datos',
    chartOptions: {
      series: []
    },
    position: {
      lat: -33.5844819,
      lng: -70.4667903
    },
    data: [],
    date: ''
  },
  autocomplete: {
    shown: false
  },
  groundOverlays: [],
  overlayViews: [],
  markers: [],
  position: {
    lat: -33.5844819,
    lng: -70.4667903
  },
  zoom: 10,
  openDefaultMarkerOption: false,
  defaultMarker: '',
  error: { state: false }
}

const namespaced: boolean = true

export const googleMaps: Module<GoogleMapsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
